import api from '../../../api';
import * as disableChat from '../../../modules/trader-chat/actions/disable-chat';

export function request(dispatch, { data }) {
    var messageTemplatesArray = [];
    messageTemplatesArray.push(data.messageTemplates);
    api.post('/chats/chat-disable', {
        messageTemplates: messageTemplatesArray,
        scheduleStart: data.scheduleStart,
        scheduleEnd: data.scheduleEnd

    }).then(
        (result) => dispatch(disableChat.finish(result)),
        (errors) => dispatch(disableChat.error(errors))
    );
}

